var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import PurchaseService from '../../../api/PurchaseService';
var initFormData = {
    organ_id: '',
    depot_id: '',
};
var ListHeader = (function (_super) {
    __extends(ListHeader, _super);
    function ListHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        return _this;
    }
    ListHeader.prototype.watchFormDataOrganId = function (newVal, oldVal) {
        this.formData.depot_id = '';
        this.getSupplierdepotOptions();
    };
    ListHeader.prototype.created = function () {
        this.purchaseService = PurchaseService.getInstance();
        this.getSupplierorganOptions();
        this.getSupplierdepotOptions();
    };
    ListHeader.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.purchaseService.getSupplierorganOptions().then(function (res) {
            _this.supplierorganOptions = [{ organ_id: '', organ_name: '全部机构' }].concat(res.data.data);
        });
    };
    ListHeader.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
        };
        this.purchaseService.getSupplierdepotOptions(params).then(function (res) {
            _this.supplierdepotOptions = [{ depot_id: '', depot_name: '全部仓库' }].concat(res.data.data);
        });
    };
    ListHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    ListHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
    };
    __decorate([
        Watch('formData.organ_id')
    ], ListHeader.prototype, "watchFormDataOrganId", null);
    ListHeader = __decorate([
        Component
    ], ListHeader);
    return ListHeader;
}(Vue));
export default ListHeader;
